
export class SubjectType {
  id: number;
  name: string;
  parent: SubjectType;
  childTypes: SubjectType[];
}
